// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Cabecera__head__Nzent {\n  text-align: center;\n}\n\n.Cabecera__logo__GGgRG {\n  width: 100%;\n  max-width: 340px;\n  height: auto;\n  display: block;\n  margin: 0 auto 18px;\n}\n\n.Cabecera__head__Nzent h1 {\n  font-size: 20px;\n  margin: 0;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n}\n\n.Cabecera__ot__jJt7O {\n  font-size: 13px;\n  color: var(--texto-tenue);\n  margin-top: 4px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"head": "Cabecera__head__Nzent",
	"logo": "Cabecera__logo__GGgRG",
	"ot": "Cabecera__ot__jJt7O"
};
export default ___CSS_LOADER_EXPORT___;
